import { Preset as PublicPreset } from '@foundation-player/runtime';

/**
 * {@inheritDoc Preset}
 *
 * @deprecated
 */
export const Preset = {
  ...PublicPreset,

  /**
   * Force the player to use the native player with features similar to the `DefaultAdvertising` preset.
   *
   * @deprecated For testing purpose only!
   *
   * @internal
   *
   * For production please request an appropriate preset from the Foundation Player team
   */
  DemoNative: 'demonative',

  /**
   * Force the player to use the dash.js player with features similar to the `DefaultAdvertising` preset.
   *
   * @deprecated For testing purpose only!
   *
   * @internal
   *
   * For production please request an appropriate preset from the Foundation Player team
   */
  DemoDashJs: 'demodashjs',

  /**
   * Force the player to use the Bitmovin player with features similar to the `DefaultAdvertising` preset.
   *
   * @deprecated For testing purpose only!
   *
   * @internal
   *
   * For production please request an appropriate preset from the Foundation Player team
   */
  DemoBitmovin: 'demobitmovin',
} as const;

export type Preset = (typeof Preset)[keyof typeof Preset];
